/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Menu_CreateInputs */

const cs_calendar_menu_create = /** @type {(inputs: Calendar_Menu_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nový úkol`)
};

const en_calendar_menu_create = /** @type {(inputs: Calendar_Menu_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New task`)
};

/**
* | output |
* | --- |
* | "New task" |
*
* @param {Calendar_Menu_CreateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_menu_create = /** @type {((inputs?: Calendar_Menu_CreateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Menu_CreateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_menu_create(inputs)
	return cs_calendar_menu_create(inputs)
});